import React from "react";
import { useNavigate } from "react-router-dom";
import Card from "../components/Card/Card";
import dados from "../data/projetosGerais.json";

function Video360i() {
  const navigate = useNavigate();
  const projetosVideo360i = dados.filter((p) => p.tags.includes("Vídeo 360i"));

  // abre a página de detalhes do projeto
  const handleCardClick = (id) => {
    navigate(`/projeto/${id}`);
  };

  return (
    <div className="pagina-categoria">
      <h1>Projetos com Vídeo 360i</h1>
      <div className="cards-container">
        {projetosVideo360i.map((projeto) => (
          <Card key={projeto.id} projeto={projeto} onClick={handleCardClick} />
        ))}
      </div>
    </div>
  );
}

export default Video360i;
